import { areaCodeLookup } from '@siteless/util';
import phoneCountries from '../config/phoneCountries';

// Build a dial-code-to-country-name map, sorted longest codes first
// so we match e.g. "355" (Albania) before "35" (no match) before "3"
let dialCodeToCountry: { code: string; name: string }[] = Object.values(
  phoneCountries,
)
  .map((c) => ({
    code: c.dialCode,
    // Strip native-language parenthetical, e.g. "Albania (Shqipëri)" → "Albania"
    name: c.name.replace(/\s*\(.*\)$/, ''),
  }))
  // Dedupe: keep first occurrence per dial code (highest priority)
  .filter(
    (entry, i, arr) => arr.findIndex((e) => e.code === entry.code) === i,
  )
  .sort((a, b) => b.code.length - a.code.length);

/**
 * Given a phone number like "+12025551234" or "+447911123456",
 * returns a location string:
 *   - For +1 numbers: US/CA area code lookup (e.g. "Washington D.C.")
 *   - For international: country name (e.g. "United Kingdom")
 *   - Falls back to undefined if nothing matches
 */
export function getPhoneLocation(phoneNumber: string): string | undefined {
  // Strip the leading "+"
  let digits = phoneNumber.startsWith('+')
    ? phoneNumber.slice(1)
    : phoneNumber;

  // NANP (+1): use the 3-digit area code lookup for state/province
  if (digits.startsWith('1') && digits.length >= 4) {
    let areaCode = digits.slice(1, 4);
    // @ts-expect-error — areaCodeLookup keys are string literals
    let location = areaCodeLookup[areaCode];
    if (location) return location;
  }

  // International: match the longest dial code prefix
  for (let { code, name } of dialCodeToCountry) {
    if (digits.startsWith(code)) return name;
  }

  return undefined;
}
